import { render, staticRenderFns } from "./ListProblemas.vue?vue&type=template&id=098a2706&scoped=true&"
import script from "./ListProblemas.vue?vue&type=script&lang=js&"
export * from "./ListProblemas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098a2706",
  null
  
)

export default component.exports